module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"timeUsed":"Tid"},"en":{"timeUsed":"Time used"}}')
  delete Component.options._Ctor
}
